import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { Site } from 'src/app/model/site';
import { selectCurrentSite, selectSites } from 'src/app/store/site/site.selector';
import { UserFileService } from 'src/app/services/user-file.service';
import { User } from 'src/app/model/user';
import * as UserFileActions from 'src/app/store/user-file/user-file.actions';
import * as UserActions from 'src/app/store/user/user.actions';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';
import { selectVctSitesList } from 'src/app/store/device-vct/device-vct.selector';
import { selectIsImpersMode } from 'src/app/store/user/user.selector';
import * as SiteActions from 'src/app/store/site/site.actions';

@Component({
	templateUrl: './site-selector.dialog.component.html',
})

export class SiteSelectorDialogComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;
	sitesVct$: Observable<Site[] | undefined>;
	sitesVctSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	sites: Site[];
	sitesVct: Site[];
	sitesAll: Site[];
	sitesOrder: Site[];

	site: Site;
	siteImage = { src: 'assets/images/tablet-bg.jpg' };
	technician: User;
	currentUser: User;
	currentTechnician: User;

	isImpersMode: boolean;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private userFileService: UserFileService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.store.dispatch(UserFileActions.getSiteImages());
		this.store.dispatch(UserActions.getTechnicians());
		this.refreshSitesOnlineDevices();
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.sites$ = this.store.select(selectSites);
		this.sitesVct$ = this.store.select(selectVctSitesList);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	subscribeAll(): void {
		this.siteSub = this.site$?.subscribe((site) => {
			this.site = site;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.sitesSub = this.sites$?.subscribe(
			(sites) => {
				this.sites = sites;
				this.mergeSite();
				//this.sitesOrder = this.orderSites(sites);
			}
		);
		this.sitesVctSub = this.sitesVct$?.subscribe(
			(sitesVct) => {
				this.sitesVct = sitesVct;
				this.mergeSite();
			}
		);
	}

	mergeSite(): void {
		this.sitesAll = [];
		if (this.sites !== undefined && this.sites !== null) {
			this.sitesAll = [...this.sites];
			if (this.sitesVct !== undefined && this.sitesVct !== null) {
				this.mergeSiteList();
			}
		} else if (this.sitesVct !== undefined && this.sitesVct !== null) {
			this.sitesAll = [...this.sitesVct];
		}
		this.sitesOrder = this.orderSites(this.sitesAll);
	}

	mergeSiteList(): void {
		for (const vctSite of this.sitesVct) {
			const find = this.sitesAll.find(s => s.Id === vctSite.Id);
			// if vctSite is not on this.sites[], i'm impersonificating user without that vctSite
			if (find === undefined) {
				if (this.isImpersMode) {
					if (this.sites.some(site => site.Id === vctSite.Id)) {
						const siteAdd = Object.assign({}, vctSite);
						siteAdd.isOnlySiteVct = true;
						this.sitesAll.push(siteAdd);
					}
				} else {
					const siteAdd = Object.assign({}, vctSite);
					siteAdd.isOnlySiteVct = true;
					this.sitesAll.push(siteAdd);
				}
			}
		}
	}

	orderSites(sites: Site[]): Site[] {
		if (sites !== undefined && sites.length > 0) {
			sites = sites.sort((a, b) => { return a.Name < b.Name ? -1 : 1 });
		}
		return sites;
	}

	private refreshSitesOnlineDevices(): void {
		if (this.isImpersMode && this.currentUser?.Id) {
			this.store.dispatch(SiteActions.getSitesOnlineDevices({ userId: this.currentUser.Id }));
			return;
		}
		this.store.dispatch(SiteActions.getSitesOnlineDevices({}));
	}

	ngOnDestroy(): void {
		this.siteSub?.unsubscribe();
		this.sitesSub?.unsubscribe();
		this.sitesVctSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
	}

	closeDialog() {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	onTablet(): boolean {
		return StandardPageLayout.onTablet(this.screenWidth);
	}

}
